import { useMemo, useState } from "react";
import { useTheme } from "../../../../context/useThemeContext";
import { hexToRGBA } from "../../../../utility/hexToRGB";
import styled from "styled-components";
import useMainStore from "../../../../stores/mainStore";
import useAbsoluteWindowStore from "../../../../stores/absoluteWindowStore";
import LeftSelectionIndicator from "./LeftSelectionIndicator";
import NoteTitle from "./NoteTitle";
import NoteDate from "./NoteDate";
import NoteContent from "./NoteContent";
import NoteContextMenuWrapper from "./NoteContextMenuWrapper";
import TagContainer from "./TagContainer";

const NoteStyled = styled.div<{ $BGColor: string }>`
    &:hover {
        .innerContainer {
            background-color: ${(props) => hexToRGBA(props.$BGColor, 0.06)};
        }
    }

    .delete-note-btn:hover {
        opacity: 1;
    }
`;

export default function Note(props: { id: string; isSelected?: boolean }) {
    const { theme } = useTheme();

    const [isRenaming, setIsRenaming] = useState(false);

    // The note ONLY needs to be rerendered on id change
    const memoizedNote = useMemo(() => {
        function OpenNote(openNew?: boolean) {
            if (openNew) {
                // If already open, close it
                if (
                    useMainStore
                        .getState()
                        .data.openedNoteIDs.includes(props.id)
                ) {
                    useMainStore.getState().remove.closeNote(props.id);
                } else {
                    useMainStore.getState().open.openNote(props.id);
                }
            } else {
                useMainStore.getState().open.replaceSelectedNote(props.id);
            }
        }

        return (
            <NoteStyled
                $BGColor={theme.accentColor}
                className="flex cursor-pointer"
                style={{
                    borderBottom: `1px solid ${hexToRGBA(
                        theme.fontColor[100],
                        0.15
                    )}`,
                }}
                onMouseDown={(e) => {
                    // e.preventDefault();
                    if (e.button === 1) OpenNote(true);
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    if (e.ctrlKey) {
                        OpenNote(true);
                    } else {
                        OpenNote();
                    }
                }}
                onContextMenu={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    useAbsoluteWindowStore
                        .getState()
                        .setPosition(e.clientX, e.clientY);
                    useAbsoluteWindowStore.getState().setWindowShowing({
                        type: "ContextMenu",
                        children: <NoteContextMenuWrapper noteID={props.id} setIsRenaming={setIsRenaming} />,
                    });
                }}
            >
                <div className="innerContainer flex gap-[10px] cursor-pointer my-2 px-[6px] relative py-1 fit-width rounded-[6px]">
                    <LeftSelectionIndicator noteID={props.id} />
                    <div className="noteContent flex flex-col flex-1 fit-width">
                        <div className="noteTitleContainer justify-between flex flex-nowrap overflow-hidden gap-2 text-nowrap">
                            <NoteTitle
                                noteID={props.id}
                                isRenaming={isRenaming}
                                setIsRenaming={setIsRenaming}
                            />
                            <NoteDate noteID={props.id} />
                        </div>
                        <NoteContent noteID={props.id} />
                        {/* <TagContainer noteID={props.id} /> */}
                    </div>
                    {/* <DeleteNote noteID={props.id} /> */}
                </div>
            </NoteStyled>
        );
    }, [props.id, theme, isRenaming]);

    return memoizedNote;
}
